import { render, staticRenderFns } from "./QualificationCategoryList.vue?vue&type=template&id=54281f29"
import script from "./QualificationCategoryList.js?vue&type=script&lang=js&external"
export * from "./QualificationCategoryList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports